import { withErrorBoundary } from '../dependencies';

import ReportTags from '../components/ReportTags';

export default withErrorBoundary(ReportTags);
